<template>
  <div class='simulation'>
    <v-breadcrumb />

    <div class='tab-header'>
      <router-link :to='{name : "simulation", params : {idExploitation, idSimulation}}' class='onglet'><span>Paramètres de la simulation</span></router-link>
      <router-link :to='{name : "simulation_result_ilot", params : {idExploitation, idSimulation}}' class='onglet'><span>Résultat</span></router-link>
    </div>
    <router-view :selected='ilots' :id-exploitation='idExploitation' :id-simulation='idSimulation' :key='$route.fullPath' @choice='choiceIlot'/>
  </div>
</template>

<script>
import store from '@/store'

const loadSimulation = (next, idExploitation, idSimulation) => {
  store.dispatch('loadSimulation', { idExploitation, idSimulation })
    .then(() => {
      next()
    })
    .catch(() => {
      next(false)
    })
}

export default {
  name: 'Simulation',

  props: {
    idExploitation: {
      type: String,
      required: true
    },
    idSimulation: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      ilots: []
    }
  },

  created () {
    this.$store.commit('SET_FILTRE_ILOT', null)
    this.$store.commit('SET_FILTRE_CULTURE', null)
    this.ilots = this.$store.state.simulation.currentSimulation.ilots
  },

  methods: {
    choiceIlot (ilots, idIlot) {
      this.ilots = ilots
      if (this.ilots.length === 0) {
        this.$router.push({
          name: 'simulation',
          params: {
            idExploitation: this.idExploitation,
            idSimulation: this.idSimulation
          }
        })
      } else if (this.ilots.length === 1) {
        this.$router.push({
          name: 'simulation_ilot',
          params: {
            idExploitation: this.idExploitation,
            idSimulation: this.idSimulation,
            idIlot: this.ilots[0]
          }
        })
      } else if (idIlot) {
        this.$router.push({
          name: 'simulation_ilot',
          params: {
            idExploitation: this.idExploitation,
            idSimulation: this.idSimulation,
            idIlot: idIlot
          }
        })
      }
    }
  },

  beforeRouteEnter (to, from, next) {
    loadSimulation(next, to.params.idExploitation, to.params.idSimulation)
  },

  beforeRouteUpdate (to, from, next) {
    let currentIdSimulation = this.$store.getters.simulationId
    if (currentIdSimulation !== to.params.idSimulation) {
      loadSimulation(next, to.params.idExploitation, to.params.idSimulation)
    } else {
      next()
    }
  }

}
</script>

<style scoped>
</style>
